module.exports = __webpack_public_path__ + "static/media/5.fd09919b.jpg";